<template>
    <div class="app-wrapper">
        <!-- <el-scrollbar> -->
            <page-header></page-header>
            <el-container >
                <page-sidebar></page-sidebar>
                <el-main class="page-main">
                    <page-breadcrumb></page-breadcrumb>
                    <router-view tag="main"/>
                    <page-footer></page-footer>
                </el-main>
            </el-container>
        <!-- </el-scrollbar> -->
        <el-backtop target=".page-main"></el-backtop>
        <player></player>
        <task-bar></task-bar>
    </div>
</template>

<script>
import PageHeader from "./pageHeader";
import PageSidebar from "./pageSidebar";
import PageFooter from "./pageFooter";
import PageBreadcrumb from './pageBreadcrumb';
import Player from '@/components/Player';
import taskBar from './Task';
export default {
    components: { PageSidebar, PageHeader, PageFooter, PageBreadcrumb, Player, taskBar },
    data() {
        return {}
    },
};
</script>

<style lang="scss" scoped>
// .app-wrapper{
//     height: 100%;
//     .el-scrollbar{
//         height: 100%;
//     }
// }
.el-container{
    height: calc(100vh - 42px);
    display: flex;
    background: #f8f8f8;
    .page-main{
        padding: 0;
        div[tag="main"]{
            background: #ffffff;
            padding: 20px;
            min-height: calc(100vh - 162px);
        }
    }
    
}
</style>